import React from 'react';
import { BorrowerList } from '../components/BorrowerList';
import { Card, CardContent } from '../components/ui/Card';
import { TrophyIcon } from 'lucide-react';
export function Dashboard() {
  return <div className="min-h-screen bg-gray-50/50" data-id="element-153">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-154">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-155">
          <div data-id="element-156">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-157">
              Welcome back, John
            </h1>
            <p className="text-gray-600 mt-1.5 text-lg" data-id="element-158">
              You have{' '}
              <span className="font-semibold text-blue-600" data-id="element-159">
                12 funded borrowers
              </span>{' '}
              ready for refinancing.
            </p>
          </div>

          <div className="flex items-center gap-2.5 text-sm bg-white px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm text-gray-700" data-id="element-160">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse flex-shrink-0" data-id="element-161"></span>
            Market rates dropped 0.125% today
          </div>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-162">
          {/* Card 1: Leaderboard Summary */}
          <Card className="bg-gradient-to-b from-blue-50/50 to-white border-blue-100/50" data-id="element-163">
            <CardContent className="p-5 h-full flex flex-col" data-id="element-164">
              <div className="flex items-center justify-between mb-4" data-id="element-165">
                <div className="flex items-center gap-2" data-id="element-166">
                  <div className="bg-yellow-100 p-1.5 rounded-lg" data-id="element-167">
                    <TrophyIcon className="w-4 h-4 text-yellow-600" data-id="element-168" />
                  </div>
                  <h3 className="font-semibold text-blue-900 text-sm" data-id="element-169">
                    Top Converters
                  </h3>
                </div>
                <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full" data-id="element-170">
                  You are #3
                </span>
              </div>

              <div className="space-y-2.5 flex-1" data-id="element-171">
                <div className="flex items-center justify-between text-sm py-1" data-id="element-172">
                  <div className="flex items-center gap-2.5" data-id="element-173">
                    <span className="w-5 h-5 flex items-center justify-center bg-yellow-100 text-yellow-700 rounded-full text-xs font-bold flex-shrink-0" data-id="element-174">
                      1
                    </span>
                    <span className="text-gray-900 font-medium" data-id="element-175">
                      David Miller
                    </span>
                  </div>
                  <span className="text-gray-600 font-semibold tabular-nums" data-id="element-176">
                    12
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm py-1" data-id="element-177">
                  <div className="flex items-center gap-2.5" data-id="element-178">
                    <span className="w-5 h-5 flex items-center justify-center bg-gray-100 text-gray-700 rounded-full text-xs font-bold flex-shrink-0" data-id="element-179">
                      2
                    </span>
                    <span className="text-gray-900 font-medium" data-id="element-180">
                      Sarah Jenkins
                    </span>
                  </div>
                  <span className="text-gray-600 font-semibold tabular-nums" data-id="element-181">
                    9
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm bg-white shadow-sm ring-1 ring-blue-200 rounded-lg py-1.5 px-2 -mx-2" data-id="element-182">
                  <div className="flex items-center gap-2.5" data-id="element-183">
                    <span className="w-5 h-5 flex items-center justify-center bg-blue-100 text-blue-700 rounded-full text-xs font-bold flex-shrink-0" data-id="element-184">
                      3
                    </span>
                    <span className="text-blue-700 font-semibold" data-id="element-185">You</span>
                  </div>
                  <span className="text-blue-700 font-bold tabular-nums" data-id="element-186">
                    7
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Card 2: Volume Goal */}
          <Card data-id="element-187">
            <CardContent className="p-5 h-full flex flex-col" data-id="element-188">
              <div className="flex items-center justify-between mb-4" data-id="element-189">
                <h3 className="font-semibold text-gray-900 text-sm" data-id="element-190">
                  Monthly Goal
                </h3>
                <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-full" data-id="element-191">
                  Ends in 4 days
                </span>
              </div>
              <div className="flex-1 flex flex-col justify-end" data-id="element-192">
                <div className="flex justify-between text-sm mb-1" data-id="element-193">
                  <span className="text-gray-600 font-medium" data-id="element-194">
                    Refinance Volume
                  </span>
                  <span className="font-bold text-gray-900 tabular-nums" data-id="element-195">
                    75%
                  </span>
                </div>
                <div className="flex justify-between text-xs text-gray-500 mb-3" data-id="element-196">
                  <span data-id="element-197">$3.75M of $5M goal</span>
                  <span data-id="element-198">$1.25M remaining</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden" data-id="element-199">
                  <div className="bg-green-500 h-full rounded-full transition-all duration-1000 ease-out" style={{
                  width: '75%'
                }} data-id="element-200"></div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Card 3: Calls Goal */}
          <Card data-id="element-201">
            <CardContent className="p-5 h-full flex flex-col" data-id="element-202">
              <div className="flex items-center justify-between mb-4" data-id="element-203">
                <h3 className="font-semibold text-gray-900 text-sm" data-id="element-204">
                  Outreach Goal
                </h3>
                <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-full" data-id="element-205">
                  Daily Target
                </span>
              </div>
              <div className="flex-1 flex flex-col justify-end" data-id="element-206">
                <div className="flex justify-between text-sm mb-1" data-id="element-207">
                  <span className="text-gray-600 font-medium" data-id="element-208">Calls Made</span>
                  <span className="font-bold text-gray-900 tabular-nums" data-id="element-209">
                    45/60
                  </span>
                </div>
                <div className="flex justify-between text-xs text-gray-500 mb-3" data-id="element-210">
                  <span data-id="element-211">15 calls to go</span>
                  <span className="text-green-600 font-medium" data-id="element-212">
                    +12 from yesterday
                  </span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden" data-id="element-213">
                  <div className="bg-blue-500 h-full rounded-full transition-all duration-1000 ease-out" style={{
                  width: '75%'
                }} data-id="element-214"></div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Full Width Table */}
        <div className="w-full" data-id="element-215">
          <BorrowerList data-id="element-216" />
        </div>
      </main>
    </div>;
}